import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
// S1
import BaseMixer from "@/router/views/BaseMixer";
import { safeUrl } from "../updatesHelpers";
/**
 * An update's URL attachments on the timeline.
 */
let UpdateLinks = /** @class */ (() => {
    let UpdateLinks = class UpdateLinks extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.safeUrl = safeUrl;
        }
    };
    __decorate([
        Prop({ default: () => [] }),
        __metadata("design:type", Array)
    ], UpdateLinks.prototype, "links", void 0);
    UpdateLinks = __decorate([
        Component({
            name: "UpdateLinks",
        })
    ], UpdateLinks);
    return UpdateLinks;
})();
export default UpdateLinks;
